import React from 'react';

import Tooltip from 'ui-library/bs/Tooltip';
import HelpIcon from 'ui-library/icons/HelpIcon';

interface Props {
  text: string;
  className?: string;
  container?: string;
}

export default function HelpToolTip({container = 'body', className, text}: Props): JSX.Element {
  return (
    <Tooltip title={text} container={container}>
      <HelpIcon className={className} />
    </Tooltip>
  );
}
